import { useEffect } from "react";

import { useQuery } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { MdWork } from "react-icons/md";
import { Link } from "react-router-dom";

import { jobsPath } from "@path/jobs_path";

import { CountJobResultsDocument, SubscribeCountJobResultsDocument } from "@/gql/graphql";
import { useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";

export default function FinishedJobs() {
  const session = useAppSelector(sessionSelector);
  const { data, subscribeToMore } = useQuery(CountJobResultsDocument);
  const { t } = useTranslation(["translation"]);

  useEffect(() => {
    return subscribeToMore({
      document: SubscribeCountJobResultsDocument,
      updateQuery: (_prev, { subscriptionData }) => {
        if (!subscriptionData.data) return;
        return { __typename: "QueryRoot", countJobResults: subscriptionData.data.countJobResults };
      },
    });
  }, [subscribeToMore]);

  const unseen = parseInt(data?.countJobResults.unseen || "0", 10) || 0;
  if (!unseen) return null;

  const label = unseen >= 100 ? "99+" : unseen.toString();

  return (
    <Link
      className="TT-unseen-jobs"
      to={jobsPath(session)}
      title={t("translation:sidebar.finished_jobs", { count: unseen })}
    >
      <MdWork />
      {unseen > 0 && <span className="TT-top-bar-badge">{label}</span>}
    </Link>
  );
}
